import React, {useEffect, useState} from 'react';
import {Helmet} from "react-helmet";
import BlockUi from "@availity/block-ui";
import ContactsForm from "../../components/contactsForm";
import {useParams} from "react-router-dom";
import axios from "../../../../helpers/axios";
import sayError from "../../../../helpers/sayError";
import {useNavigate} from "react-router";
import {CounterpartiesContacts} from "../../../routesConstants";

const EditContacts = () => {
  const [loading, setLoading] = useState()
  const {id} = useParams();
  const [data, setData] = useState()
  const navigate = useNavigate()
  useEffect(() => {
    if( id && !data){
      axios.get('/api/counterparty/contacts/'+id)
        .then(({data})=>{
          setData(data.contacts)
        })
        .catch(sayError)
        .finally(()=>setLoading(false))
    }
  }, []);
  const onSubmit = (data) =>{
    setLoading(true)
    axios.patch('/api/counterparty/contacts/'+id, data)
      .then(()=>{
        navigate(CounterpartiesContacts)
      })
      .finally(()=>setLoading(false))
  }
  return (
    <>
      <Helmet>
        <title>Контакт</title>
      </Helmet>
      <BlockUi blocking={loading}>
        {data && <ContactsForm data={data} onSubmit={onSubmit}/>}
      </BlockUi>
    </>
  );
};

export default EditContacts;
